module.exports = __webpack_public_path__ + "img/icon-cargo-enable.7cf92990.svg";